import { render, staticRenderFns } from "./NavigationBottomMobile.vue?vue&type=template&id=530f3374&scoped=true&"
import script from "./NavigationBottomMobile.vue?vue&type=script&lang=js&"
export * from "./NavigationBottomMobile.vue?vue&type=script&lang=js&"
import style0 from "./NavigationBottomMobile.vue?vue&type=style&index=0&id=530f3374&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530f3374",
  null
  
)

export default component.exports